import React, { useState } from "react"
import {
    componentStyles,
    ContrastButton,
    useTheme,
} from "@mallardbay/lib-react-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFilter } from "@fortawesome/free-solid-svg-icons/faFilter"

import { getUrlQueryParamsObj } from "~utils/url-param-helpers"
import { useTabletMediaQueries } from "~components/shared/todo-lib-react-components/hooks/use-media-queries"
import COPY from "~config/copy-constants"

import SearchFiltersModal from "./search-filters-modal"
import FilterTag from "./filter-tag"

export default function SearchFiltersButton() {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    function onOpen() {
        setIsOpen(true)
    }

    function onClose() {
        setIsOpen(false)
    }

    const { isLargerThanTablet } = useTabletMediaQueries()
    const numberOfFilters = getNumberOfFilters()
    const styles = useStyleProps({ numberOfFilters })

    return (
        <>
            <ContrastButton style={styles.button} onClick={onOpen}>
                {isLargerThanTablet && COPY.FILTERS}
                {isLargerThanTablet && numberOfFilters > 0 ? (
                    <FilterTag>{numberOfFilters}</FilterTag>
                ) : (
                    <FontAwesomeIcon
                        icon={faFilter}
                        style={styles.filterIcon}
                    />
                )}
            </ContrastButton>
            <SearchFiltersModal isOpen={isOpen} onClose={onClose} />
        </>
    )
}

function useStyleProps({ numberOfFilters }: { numberOfFilters: number }) {
    const { colors } = useTheme()
    const { isLargerThanTablet } = useTabletMediaQueries()
    const borderWidth = numberOfFilters > 0 ? "2px" : "1px"
    const borderColor =
        numberOfFilters > 0
            ? colors.contentPrimary
            : colors.contentInverseSecondary

    return componentStyles({
        button: {
            fontWeight: "600",
            fontSize: "0.9rem",
            padding: { base: "9px", md: "10px 16px" },
            color: colors.contentPrimary,
            backgroundColor: colors.bgColor,
            borderWidth,
            borderStyle: "solid",
            borderColor,
            borderRadius: { base: "50%", md: "8px" },
            ":hover": {
                backgroundColor: colors.backgroundTertiary,
            },
        },
        filterIcon: {
            marginLeft: isLargerThanTablet ? "8px" : "0",
            fontSize: 16,
        },
    })
}

function getNumberOfFilters() {
    const { priceMin, priceMax, type, species, amenities, startDate, endDate } =
        getUrlQueryParamsObj()
    let num = 0
    if (priceMin || priceMax) num += 1
    if (type) num += 1
    if (species) num += 1
    if (amenities) num += 1
    if (startDate || endDate) num += 1
    return num
}
